import * as types from './mutation-types'


export const loadQvctAnwerMark = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/answer/mark/collection', data).then((response) => {
            commit(types.LOAD_QVCT_ANSWER_MARK, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeQvctAnwerMark = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/answer/mark', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateQvctAnwerMark = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/answer/mark/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteQvctAnwerMark = ({commit}, {id}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/qvct/answer/mark/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
